import type { IconProps } from "types";

const ChannelOther = ({ color = "#141516", width = "20", height = "20" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z"
        fill={color}
      />
      <path
        d="M14.5 11.5C15.3284 11.5 16 10.8284 16 10C16 9.17157 15.3284 8.5 14.5 8.5C13.6716 8.5 13 9.17157 13 10C13 10.8284 13.6716 11.5 14.5 11.5Z"
        fill={color}
      />
      <path
        d="M5.5 11.5C6.32843 11.5 7 10.8284 7 10C7 9.17157 6.32843 8.5 5.5 8.5C4.67157 8.5 4 9.17157 4 10C4 10.8284 4.67157 11.5 5.5 11.5Z"
        fill={color}
      />
    </svg>
  );
};
export default ChannelOther;
